(function () {
  // One-open-at-a-time accordion (parallax matches .product-main: CSS ::before + background-attachment: fixed)
  function initAccordions(section) {
    var container = section.querySelector('[data-faq-accordions]');
    if (!container) return;

    var items = container.querySelectorAll('.section-faq__item');

    items.forEach(function (item) {
      var summary = item.querySelector('.section-faq__summary');

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.hasAttribute('open');

        items.forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });

        if (isOpen) {
          item.removeAttribute('open');
        } else {
          item.setAttribute('open', '');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-section-faq]').forEach(function (section) {
      initAccordions(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
